import Nav from '../nav_home_out/nav_home_out'
import { useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import Actions from "./actions"
import './AdminActions.css'
function AdminActions(){
  const logout= useNavigate();
  useEffect(()=>{
    if(localStorage.getItem('auth')=='false' || localStorage.getItem('auth')==null){
      logout('/admin')
    }
  },[])
    return (
        <div>
            <div className='actions'>
                <Actions action="Add New Certificate" url="/uploadcertifications"/>
                <Actions action="Add New Skill" url="/addskill"/>
            </div>
            <Nav/>
        </div>
    )
}

export default AdminActions;